var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticClass: "align-center mb-3"
        },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center flex-wrap",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "mr-auto my-1"
                },
                [
                  _c(
                    "gg-card-title",
                    {
                      staticClass: "pt-0"
                    },
                    [_vm._v("Email")]
                  )
                ],
                1
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "my-1",
                  attrs: {
                    href: "https://www.greengeeks.com/email-hosting/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }
                },
                [
                  _vm._v(" Buy Email "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "ml-1",
                      attrs: {
                        small: ""
                      }
                    },
                    [_vm._v("mdi-open-in-new")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "gg-card",
        {
          attrs: {
            flat: ""
          }
        },
        [
          _c(
            "gg-card-text",
            [
              _c(
                "table-wrapper",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.rows,
                      loading: _vm.isLoading,
                      "loading-text": "Loading your email accounts…",
                      "item-key": "key",
                      "disable-sort": "",
                      "disable-pagination": "",
                      "hide-default-footer": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.domain",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            item.addon
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "pl-10 text--secondary"
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: {
                                          small: "",
                                          "aria-hidden": "true"
                                        }
                                      },
                                      [_vm._v("mdi-subdirectory-arrow-right")]
                                    ),
                                    _vm._v(_vm._s(item.domain) + " ")
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "d-flex align-center"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mr-1",
                                        staticStyle: {
                                          width: "28px"
                                        }
                                      },
                                      [
                                        item.addonCount
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  "aria-expanded": String(
                                                    item.expanded
                                                  ),
                                                  "aria-label": ""
                                                    .concat(
                                                      item.expanded
                                                        ? "Hide"
                                                        : "Show",
                                                      " addon domains of "
                                                    )
                                                    .concat(item.domain)
                                                },
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.toggle(
                                                      item.serviceId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: ""
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.expanded
                                                          ? "mdi-chevron-down"
                                                          : "mdi-chevron-right"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-medium"
                                        },
                                        [_vm._v(_vm._s(item.domain))]
                                      ),
                                      item.addonCount && !item.expanded
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ml-2 caption text--secondary"
                                            },
                                            [
                                              _vm._v(
                                                " +" +
                                                  _vm._s(item.addonCount) +
                                                  " addon " +
                                                  _vm._s(
                                                    item.addonCount === 1
                                                      ? "domain"
                                                      : "domains"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      item.planLabel
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "caption text--secondary"
                                            },
                                            [_vm._v(_vm._s(item.planLabel))]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                          ]
                        }
                      },
                      {
                        key: "item.mailboxCount",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [
                            item.failed
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "text--secondary"
                                  },
                                  [_vm._v("Unavailable")]
                                )
                              : [_vm._v(_vm._s(item.mailboxCount))]
                          ]
                        }
                      },
                      {
                        key: "item.storage",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [
                            !item.failed
                              ? [_vm._v(_vm._s(item.storage))]
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref4) {
                          var item = _ref4.item
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex justify-end"
                              },
                              [
                                _c(
                                  "gg-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      secondary: "",
                                      to: _vm.accountPath(
                                        item.domain,
                                        "accounts"
                                      ),
                                      "aria-label": "Mailboxes on ".concat(
                                        item.domain
                                      )
                                    }
                                  },
                                  [_vm._v(" Mailboxes ")]
                                )
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "no-data",
                        fn: function fn() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "py-8 text-center"
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "mb-2 font-weight-medium"
                                  },
                                  [
                                    _vm._v(
                                      "You don't have any email accounts yet."
                                    )
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "mb-0"
                                  },
                                  [
                                    _vm._v(
                                      "Hosting plans that include email will show up here."
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }